import { useCoworkerStore } from '@/store';
import useStarterPrompts from './useStarterPrompts';
import useWorkStarterProject from './useWorkStarterProject';

export { STARTER_CACHE_TTL_MS as WORK_STARTER_CACHE_TTL_MS } from './useStarterPrompts';

export default function useWorkStarterPrompts(options = {}) {
  const includeMemory = useCoworkerStore((s) => s.composerIncludeMemory);
  const project = useWorkStarterProject(options.collectionId);
  return useStarterPrompts({ ...options, mode: 'work', project, includeMemory });
}
